import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import IconArrowDownward from 'images/order-arrow.png';
import { DESC } from 'config/constants';
import { styles, Th, OrderIcon } from './styles';

const TableAppCell = ({
  children,
  classes,
  className,
  type,
  sort,
  order,
  style = {},
  ...rest
}) => {
  const componentClasses = classNames(
    { [className]: className },
    { [classes.tableTh]: type === 'th' },
    { [classes.tableTd]: type !== 'th' },
    { [classes.sortingActive]: sort },
  );

  const isAsc = sort && order === DESC;

  const tableInside = type !== 'th'
    ? children
    : (
      <Th>
        {children}
        {sort && <OrderIcon ascending={isAsc}><img alt="" src={IconArrowDownward} /></OrderIcon>}
      </Th>
    );

  return (
    <TableCell
      {...rest}
      className={componentClasses}
      style={style}
    >
      {tableInside}
    </TableCell>
  );
};

export default withStyles(styles)(TableAppCell);



// WEBPACK FOOTER //
// ./src/components/IterioApp/components/TableApp/TableAppCell.jsx